export default __webpack_public_path__ + "static/media/truewallet.8fb2d62e.svg";